const DefaultBreakPoints = {xxs: 320, xs: 672, sm: 1056, md: 1312, lg: 1584};

export default DefaultBreakPoints;